// extracted by css-extract-rspack-plugin
export default {"root":"fMmy0J","badge":"hKbddb","draft":"SrDUPq","pending-deletion":"L8q0a_","pendingDeletion":"L8q0a_","need-core":"r1XjWM","needCore":"r1XjWM"};